import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { withList } from "../../../../../../../components/list";
import OrderItem from "../order-item/normal/index";
import OrderReturnItem from "../order-item/return";

export const OrderReturnList = withList(props =>{
    useStyles(cls);
    const { orders } = props;

    return <div className={cls.OrderList}>
        {
            orders?.map((order, index)=>(<OrderReturnItem key={order?.id+index} returnOrderItem={order} />))
        }
    </div>
})

export default withList(props =>{
    useStyles(cls);
    const { orders } = props;

    return <div className={cls.OrderList}>
        {
            orders?.map((order, index)=>(<OrderItem key={order?.id+index} orderItem={order} />))
        }
    </div>
})